import type { ReactNode } from 'react';
import classnames from 'classnames';

interface IContentProps {
    children: ReactNode;
    className?: string;
}

export function Content(props: IContentProps) {
    return <div className={classnames('content', props.className || '')}>{props.children}</div>;
}
